<template>
  <div>
    <LeftSidebar
      :visible="visible"
      baseClass="add-term-wrapper"
      :title="title"
      :hasHeaderRightIcon="false"
    >
      <template>
        <div class="padding-16" v-if="visible">
          <EnumDropdown
            :title="$lang.attachmentType"
            :label="$lang.attachmentType"
            :placeholder="$lang.attachmentType_select"
            :value="form.attachmentType"
            name="attachmentType"
            id="attachmentType"
            :categoryName="categoryName"
            :multiple="false"
            :vuelidateObj="$v.form.attachmentType"
            :disabled="!SHOULD_EDITABLE_ATTACHMENT_TYPE"
            @input="input"
            @focus="resetValidation"
            @blur="checkValidation"
          />
          <Input
            :title="$lang.attachmentCaption"
            :label="$lang.attachmentCaption"
            :placeholder="$lang.attachmentCaptionDays"
            :infoTooltip="$lang.attachmentCaptionTooltip"
            :value="form.attachmentCaption"
            name="attachmentCaption"
            id="attachmentCaption"
            type="text"
            :vuelidateObj="$v.form.attachmentCaption"
            @input="input"
            @focus="resetValidation"
            @blur="checkValidation"
          />
        </div>
      </template>
      <template #footer>
        <Button
          variant="filled-complementary"
          :text="$lang.cancel"
          class="mobile-width-percent-100 tablet-width-percent-100"
          contentClass="justify-content-center"
          @click="handleClose"
        />
        <Button
          v-if="checkPermission(permissions, ['admin', 'edit'])"
          variant="primary"
          :text="$lang.submit"
          class="mobile-width-percent-100 tablet-width-percent-100"
          contentClass="justify-content-center"
          :loading="loading"
          @click="handleSubmit"
        />
      </template>
    </LeftSidebar>
  </div>
</template>

<script>
import inputMixin from "@/mixin/inputMixin.vue";
import { LeftSidebar } from "@/components/re-design";
import { Input, EnumDropdown, Button } from "@/components/re-design/forms";
import { required, requiredIf } from "vuelidate/lib/validators";
import { pathOr } from "ramda";
import { checkPermission, generateError, toastAlert } from "@/shared/utils";

export default {
  mixins: [inputMixin],
  inject: [
    "permissions",
    "handleReloadList",
    "updateMethod",
    "SHOULD_EDITABLE_ATTACHMENT_TYPE",
  ],
  components: { LeftSidebar, Input, EnumDropdown, Button },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    file: {
      type: Object,
      default: null,
    },
    title: {
      type: String,
      default: "",
    },
    submitMethod: {
      type: Function,
      default: () => {},
    },
  },
  validations() {
    return {
      form: {
        attachmentType: {
          required: requiredIf(() => this.SHOULD_EDITABLE_ATTACHMENT_TYPE),
        },
        attachmentCaption: { required },
      },
    };
  },
  data() {
    return {
      form: {
        attachmentType: null,
        attachmentCaption: null,
      },
      categoryName: null,
      loading: false,
    };
  },

  watch: {
    file: {
      immediate: true,
      handler(value) {
        if (value) {
          this.form.attachmentType = pathOr(null, ["attachmentType"], value);
          this.form.attachmentCaption = pathOr(null, ["caption"], value);
          this.categoryName = pathOr(
            null,
            ["attachmentType", "category_name"],
            value
          );
        }
      },
    },
  },
  methods: {
    checkPermission,
    handleClose() {
      this.$emit("handleClose");
    },
    async handleSubmit() {
      this.$v.$touch();
      if (this.$v.$anyError || this.loading) return;

      try {
        this.loading = true;
        const { code } = this.file;
        const attachmentTypeId = pathOr(
          null,
          ["attachmentType", "id"],
          this.form
        );
        const attachmentCaption = this.form.attachmentCaption;
        const response = await this.updateMethod(
          code,
          attachmentTypeId,
          attachmentCaption
        );
        const { message } = response;
        toastAlert(message);
        this.handleClose();
        this.handleReloadList();
      } catch (error) {
        generateError(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
